import { createCrudSlice } from './createCrudSlice';
import { kitchensApi } from '../../services/api';

const { reducer, actions } = createCrudSlice('kitchens', kitchensApi);

export const {
  fetchAll: fetchKitchens,
  fetchById: fetchKitchenById,
  create: createKitchen,
  update: updateKitchen,
  remove: deleteKitchen,
  clearError,
  clearCurrentItem,
} = actions;

export default reducer;
